import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { NAV_ITEMS } from "@/app/router/nav.config";

export function Breadcrumbs() {
  const location = useLocation();
  const current = NAV_ITEMS.find((item) => location.pathname.startsWith(item.path));

  return (
    <nav className="flex items-center gap-1.5 text-sm text-ink-muted">
      <Link to="/dashboard" className="hover:text-ink">
        Eyy Admin
      </Link>
      {current && (
        <>
          <ChevronRight className="h-3.5 w-3.5" />
          <span className="font-medium text-ink">{current.label}</span>
        </>
      )}
    </nav>
  );
}
